<template>
    <div class="collect">
        <template class="table-head">
            <el-table :data="refundLists" border height="500" ref="dragTable" v-loading = "isLoading" :default-sort = "{prop: 'applyTime', order: 'descending'}" @cell-dblclick="celldblclick">
                <el-table-column sortable show-overflow-tooltip :prop="item.prop" :label="item.label" v-for="(item, index) in tableDataRefunds" :key="index" align="center">
                    <template slot-scope="scope">
                        <a
                        v-if="item.status === 'link' && scope.row.approveStatus === BMSDEPOSITAPSTATUS.TO_BE_SUBMITTED"
                        :class="scope.row.approveStatus === BMSDEPOSITAPSTATUS.TO_BE_SUBMITTED ? 'examine' : ''"
                        @click.prevent="linkToinfo(scope.row)">
                            {{scope.row[item.prop]}}
                        </a>
                        <span v-else>{{scope.row[item.prop]}}</span>
                    </template>
                </el-table-column>

                <el-table-column fixed="right" label="操作" width="120" align="center">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.approveStatus === BMSDEPOSITAPSTATUS.TO_BE_SUBMITTED" @click="handleClick(scope.row)" type="text" size="small">电子签章撤回</el-button>
                        <span v-else></span>
                    </template>
                </el-table-column>
            </el-table>
        </template>
        <Pending
            v-if="refundShowList"
            :ruleFormObj="ruleFormObj"
            :uploadLookData="uploadLookData"
            :refundShowList.sync="refundShowList"
            @refundOk="refundOk"
            @refundCell="refundCell"
        ></Pending>
    </div>
</template>

<script>
import data from '../data.js';
// eslint-disable-next-line no-unused-vars
import { BMSDEPOSITAPSTATUS } from '../../../../utils/configuration';
// import { getRefundDetails } from '../../../../api/depositDetails';
import { getUpdate, getUploadLook, getWithdrawal } from '../../../../api/refund';
import Pending from '../dialog/Pending';
export default {
    inject: ['getParams'],
    components: { Pending },
    props: {
        refundList: {
            type: Object
        },
        refundLists: {
            type: Array
        }
    },
    data() {
        return {
            BMSDEPOSITAPSTATUS: {
                TO_BE_SUBMITTED: '10'
            },
            refundShowList: false,
            isLoading: false,
            data,
            ruleFormObj: {},
            uploadLookData: [],
            tableDataRefunds: [],
            uploadId: ''
        };
    },
    methods: {
        handleClick(row) {
            this.isLoading = true;
            const params = { zfBillNo: row.applyNo };
            getWithdrawal(params).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('电子签章撤回成功');
                }
                this.getParams();
                this.isLoading = false;
            }).catch(() => {});
        },
        celldblclick(row) {},
        async linkToinfo(row) {
            this.uploadId = row.jobId;
            await this.uploadLook();
            this.ruleFormObj = row;
            if (this.ruleFormObj.esignature && this.ruleFormObj.esignature === '1') {
                this.refundShowList = true;
            } else {
                return this.$message.warning('电子签章已完成方能提交');
            }
        },
        async uploadLook() {
            this.isLoading = true;
            const params = { subnum1: this.uploadId };
            await getUploadLook(params).then(res => {
                if (res && res.code === '0') {
                    this.uploadLookData = res.data.list;
                }
                this.isLoading = false;
            }).catch(() => {});
        },
        refundCell() { this.refundShowList = false; },
        refundOk(formName) {
            if (formName.state) {
                const params = { applyNo: formName.applyNo };
                getUpdate(params).then(res => {
                    if (res && res.code === '0') {
                        this.$message.success('保存成功');
                        this.refundShowList = false;
                        this.getParams();
                    }
                }).catch(() => {});
            } else {
                return false;
            }
        }
        // load() {
        //     const params = { supCashNo: this.$route.query.supCashNo, suppliersCode: this.refundList.suppliersCode };
        //     getRefundDetails(params).then(res => {}).catch(() => {});
        // }
    },
    created() {
        this.tableDataRefunds = data.tableDataRefunds;
    },
    mounted() {},
    watch: {
        // 'refundList': {
        //     deep: true,
        //     handler: function(newVal, oldVal) {
        //         this.companyCode = newVal.companyCode ? newVal.companyCode : '';
        //         this.siteCode = newVal.siteCode ? newVal.siteCode : '';
        //         this.supCode = newVal.supCode ? newVal.supCode : '';
        //         newVal && this.load();
        //     }
        // }
    }
};
</script>

<style lang="less">
.collect {
    .examine {
        color: #00a9ac;
        cursor: pointer;
    }
}
</style>